import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import ApiService from 'src/services/ApiService';
import { connect } from 'react-redux';
import * as postActions from 'src/store/action/post';
import { udpateLogPost } from 'src/utils/common';
import localStorage from "src/utils/local-storage";

const loadOptions = inputValue =>
  new Promise(resolve => {
    if (inputValue) {
      ApiService.get(`/users?_sort=createdAt:DESC&_limit=-1&blocked=false&username_contains=${inputValue}`).then(data => {
        const userOptions = data.map(user => {
          return {
            value: user._id,
            label: user.fullname,
            username: user.username
          }
        });
        resolve(userOptions);
      });
    } else {
      resolve(null);
    }
  });

const ShareEditPermissionTab = (props) => {
  const [log, setLog] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState(null);
  const _user = localStorage.get("_user");

  const getDefaultOptions = () => {
    const { primary_category, id: userId } = _user;

    if (primary_category) {
      ApiService
        .get(`/users?_sort=createdAt:DESC&_limit=10&blocked=false&primary_category.url=${primary_category.url}&id_ne=${userId}`)
        .then(users => {
          if (users) {
            const convertedUsers = users.map(u => {
              return {
                value: u._id,
                label: u.fullname,
                username: u.username
              }
            });
            setDefaultOptions(convertedUsers);
          }          
        });
    }
  }

  const handleOnChange = (objValue, meta) => {
    if (objValue && props.post) {
      const { value: idUser, label: fullNameUser, username } = objValue;
      const { currentPost } = props.post;
      currentPost.user = idUser;
      currentPost.log_action = `${log ? log : ''}${udpateLogPost(`Chuyển bài viết cho ${username} (${fullNameUser})`)}`;
      props.setCurrentPost(currentPost);
    }
  }

  useEffect(() => {
    if (props.post) {
      const { currentPost } = props.post;
      setLog(currentPost.log_action);
    }

    getDefaultOptions();

  }, []);

  return (
    <div className="row card">
      <div className="card-header col-12">
        <h4 className="card-title">Chuyển bài viết cho người khác</h4>
        <div className="card-tools">
          <button type="button" className="btn btn-tool" data-card-widget="collapse">
            <i className="fas fa-minus"></i>
          </button>
        </div>
      </div>

      <div className="card-body">
        <AsyncSelect
          cacheOptions
          loadOptions={loadOptions}
          defaultOptions={defaultOptions}
          placeholder="Nhập tên user"
          onChange={handleOnChange}
          isClearable={true}
        />

        <p className="mt-2">Chú ý: Bạn sẽ không được chỉnh sửa bài viết sau khi lưu.</p>
      </div>
    </div>
  )
}

export default connect(store => {
  return {
    post: store.post,
  };
}, dispatch => {
  return {
    setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
  }
})(ShareEditPermissionTab);
